// 网站配置存储
let siteConfig = null

// 设置网站配置
export function setSiteConfig(config) {
  siteConfig = config
  // 同时存储到localStorage，以便刷新后使用
  if (config) {
    localStorage.setItem('site_config', JSON.stringify(config))
  }
}

// 获取网站配置
export function getSiteConfig() {
  // 优先使用内存中的配置
  if (siteConfig) {
    return siteConfig
  }
  // 如果内存中没有，尝试从localStorage读取
  const stored = localStorage.getItem('site_config')
  if (stored) {
    try {
      siteConfig = JSON.parse(stored)
      return siteConfig
    } catch (e) {
      console.error('解析网站配置失败:', e)
    }
  }
  return null
}

// 清除网站配置
export function clearSiteConfig() {
  siteConfig = null
  localStorage.removeItem('site_config')
}

